import { Stack } from '@mui/material';
import React from 'react';
import { AppColors } from '../../../Utils/helper/AppColors';
import { GiCheckMark } from 'react-icons/gi';
import { GoDotFill } from 'react-icons/go';

const CustomStepComponent = (status) => {

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			width={24}
			sx={theme => ({
               backgroundColor : status.completed || status?.active ? theme.palette.primary.primary_shade : '#f8fbfb',
			   borderColor : status.completed || status?.active ? theme.palette.primary.primary_shade : '#EAECF0',
			})}
			border="1.5px solid"
			height={24}
			borderRadius={50}
		>
			{status?.completed && <GiCheckMark size={12} color={AppColors.WHITE} />}
			{status?.active && <GoDotFill size={14} color={AppColors.WHITE} />}
			{!status.completed && !status.active && <GoDotFill size={14} color="#D0D5DD" />}
		</Stack>
	);
};

export default CustomStepComponent;
